import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private pendingScrollTo: string | null = null;

  constructor(private router: Router) {}

  navigateToHomeWithScroll(sectionId: string) {
    const path = this.router.url.split('?')[0];
    const isHomePage = path === '/katalog';

    if (isHomePage) {
      setTimeout(() => {
        this.scrollToSection(sectionId, 'smooth');
      }, 100);
    } else {
      this.pendingScrollTo = sectionId;
      this.router.navigate(['/katalog']);
    }
  }

  checkAndScroll() {
    if (!this.pendingScrollTo) return;

    const sectionId = this.pendingScrollTo;
    this.pendingScrollTo = null;
    // После перехода с другой страницы секции появляются не сразу — повторяем,
    // и скроллим без анимации, чтобы не «ломалось» на неготовом DOM.
    this.scrollToSectionWhenReady(sectionId, 'auto');
  }

  private scrollToSectionWhenReady(sectionId: string, behavior: ScrollBehavior, attempt = 0): void {
    const maxAttempts = 40;
    const delayMs = 50;

    if (this.scrollToSection(sectionId, behavior)) {
      return;
    }

    if (attempt < maxAttempts) {
      setTimeout(() => this.scrollToSectionWhenReady(sectionId, behavior, attempt + 1), delayMs);
    }
  }

  /**
   * @returns true если элемент найден и скролл выполнен
   */
  private scrollToSection(sectionId: string | null, behavior: ScrollBehavior): boolean {
    if (!sectionId) return false;

    const element = document.getElementById(sectionId);
    if (!element) return false;

    element.scrollIntoView({ behavior, block: 'start' });
    return true;
  }
}
